/**
 * Client-side checks before upload. Prefer MIME; fall back to extension when empty (common on mobile / some OS).
 */
const IMAGE_EXT_RE = /\.(jpe?g|png|gif|webp|avif|svg|bmp|tiff?|ico|heic|heif|jxl)$/i;

export function isAllowedImageFile(file) {
  if (!file) return false;
  const type = (file.type || '').toLowerCase();
  if (type.startsWith('image/')) return true;
  const name = file.name || '';
  return IMAGE_EXT_RE.test(name);
}
